import './Navigation.css';
export var button = '_swz1ff2-3-5-0';
export var inlineNav = '_swz1ff4-3-5-0';
export var isDisabled = '_swz1ff1-3-5-0';
export var isSelected = '_swz1ff0-3-5-0';
export var menuLink = '_swz1ff3-3-5-0';